<template>
  <div>
    <v-toolbar color="grey lighten-2" absolute flat height="24em" tabs>
      <template slot="extension">
        <v-tabs v-model="currentTab" centered flat icons-and-text class="pb-4" color="grey lighten-2">
          <v-tab href="#tab-1" to="/reportes/people" v-if="$store.state.permissions.canViewReportes && $store.getters.isSafRole && $store.state.permissions.canViewPersonasReporteSistema">
            <span>Personas</span>
            <v-icon>fa-users</v-icon>
          </v-tab>
          <v-tab href="#tab-2" to="/reportes/presentaciones" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewPresentaciones && $store.state.permissions.canViewPresentacionesReporteSistema">
            <span>Presentaciones</span>
            <v-icon>mdi-file-document-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-3" to="/reportes/consultas" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConsultas && $store.state.permissions.canViewConsultasReporteSistema">
            <span>Consultas</span>
            <v-icon>mdi-comment-text-outline</v-icon>
          </v-tab>
          <v-tab href="#tab-4" to="/reportes/expedientes" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewExpedientes && $store.state.permissions.canViewExpedientesReporteSistema">
            <span>Expedientes</span>
            <v-icon>inbox</v-icon>
          </v-tab>
          <v-tab href="#tab-5" to="/reportes/contratos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos && $store.state.permissions.canViewContratosResumenJugadoresReporteSistema">
            <span>Contratos Resumen<br/>Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-6" to="/reportes/contratos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewContratosResumenCuerpoTecnicoReporteSistema">
            <span>Contratos Resumen<br/>Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-7" to="/reportes/condiciones/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewCondicionesJugadoresReporteSistema">
            <span>Cond. Salariales<br/>Jugadores</span>
            <v-icon>request_quote</v-icon>
          </v-tab>
          <v-tab href="#tab-8" to="/reportes/condiciones/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewCondicionesCuerpoTecnicoReporteSistema">
            <span>Cond. Salariales<br/>Cuerpo Técnico</span>
            <v-icon>request_quote</v-icon>
          </v-tab>
          <v-tab href="#tab-9" to="/reportes/pagos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewPagosJugadoresReporteSistema">
            <span>Pagos<br/>Jugadores</span>
            <v-icon>local_atm</v-icon>
          </v-tab>
          <v-tab href="#tab-10" to="/reportes/pagos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewConditions && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewPagosCuerpoTecnicoReporteSistema">
            <span>Pagos<br/>Cuerpo Técnico</span>
            <v-icon>local_atm</v-icon>
          </v-tab>
          <v-tab href="#tab-11" to="/reportes/transferencias" v-if="$store.state.permissions.canViewTransferencias && $store.getters.isSafRole && $store.state.permissions.canViewTransferenciasReporteSistema">
          <span>Transferencias<br/>entre Clubes</span>
            <v-icon>transfer_within_a_station</v-icon>
          </v-tab>
          <v-tab href="#tab-12" to="/reportes/contratos/vencimientos/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos && $store.state.permissions.canViewVencimientosContratosJugadoresReporteSistema">
            <span>Vencimientos Contratos<br/>Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-13" to="/reportes/contratos/vencimientos/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewVencimientosContratosCuerpoTecnicoReporteSistema">
            <span>Vencimientos Contratos<br/>Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-14" to="/reportes/adendas/jugadores" v-if="$store.state.permissions.canViewReportes && $store.getters.isSafRole && $store.state.permissions.canViewContratos && $store.state.permissions.canViewAdendasJugadoresReporteSistema">
            <span>Adendas<br/>Jugadores</span>
            <v-icon>post_add</v-icon>
          </v-tab>
          <v-tab href="#tab-15" to="/reportes/adendas/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewAdendasCuerpoTecnicoReporteSistema">
            <span>Adendas<br/>Cuerpo Técnico</span>
            <v-icon>post_add</v-icon>
          </v-tab>
          <v-tab href="#tab-18" to="/reportes/informes/partidos" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewReportFaults && $store.state.permissions.canViewInformesPartidosReporteSistema">
            <span>Informes<br/>Partidos</span>
            <v-icon>fa-futbol</v-icon>
          </v-tab>
          <v-tab href="#tab-16" to="/reportes/contratos/detalle/jugadores" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewContratos && $store.state.permissions.canViewContratosJugadoresReporteSistema">
            <span>Contratos<br/> Jugadores</span>
            <v-icon>gavel</v-icon>
          </v-tab>
          <v-tab href="#tab-17" to="/reportes/contratos/detalle/cuerpo-tecnico" v-if="$store.state.permissions.canViewReportes &&
          $store.getters.isSafRole && $store.state.permissions.canViewCuerpoTecnico && $store.state.permissions.canViewContratosCuerpoTecnicoReporteSistema">
            <span>Contratos<br/> Cuerpo Técnico</span>
            <v-icon>gavel</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <div class="top-spacing">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentTab: null,
      tabs: [
        { id: 1, componentName: 'People' },
        { id: 2, componentName: 'Presentation' },
        { id: 3, componentName: 'Consulta' },
        { id: 4, componentName: 'Expediente' },
        { id: 5, componentName: 'ContratoJugadores' },
        { id: 6, componentName: 'ContratoCuerpoTecnico' },
        { id: 7, componentName: 'CondicionJugadores' },
        { id: 8, componentName: 'CondicionCuerpoTecnico' },
        { id: 9, componentName: 'PagosJugadores' },
        { id: 10, componentName: 'PagosCuerpoTecnico' },
        { id: 11, componentName: 'Transferencias' },
        { id: 12, componentName: 'VencimientoContratoCuerpoTecnico' },
        { id: 13, componentName: 'VencimientoContratoJugadores' },
        { id: 14, componentName: 'AdendasJugadores' },
        { id: 15, componentName: 'AdendasCuerpoTecnico' },
        { id: 16, componentName: 'InformesPartidos' }
      ]
    }
  },

  created () {
    this.checkDefaultRoute()
  },

  watch: {
    // Escuchamos cambios en la ruta por si el usuario hace clic en el menú lateral de nuevo
    '$route.path' (newPath) {
      if (newPath === '/reportes' || newPath === '/reportes/people') {
        this.checkDefaultRoute()
      }
    }
  },

  methods: {
    checkDefaultRoute () {
      const p = this.$store.state.permissions
      const isSaf = this.$store.getters.isSafRole
      const currentPath = this.$route.path

      if (currentPath === '/reportes' || (currentPath === '/reportes/people' && !p.canViewPersonasReporteSistema)) {
        if (isSaf && p.canViewPersonasReporteSistema) {
          this.redirectIfNotCurrent('/reportes/people')
        } else if (isSaf && p.canViewPresentaciones && p.canViewPresentacionesReporteSistema) {
          this.redirectIfNotCurrent('/reportes/presentaciones')
        } else if (isSaf && p.canViewConsultas && p.canViewConsultasReporteSistema) {
          this.redirectIfNotCurrent('/reportes/consultas')
        } else if (isSaf && p.canViewExpedientes && p.canViewExpedientesReporteSistema) {
          this.redirectIfNotCurrent('/reportes/expedientes')
        } else if (isSaf && p.canViewContratos && p.canViewContratosJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/jugadores')
        } else if (isSaf && p.canViewCuerpoTecnico && p.canViewContratosCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/cuerpo-tecnico')
        } else if (isSaf && p.canViewConditions && p.canViewCondicionesJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/condiciones/jugadores')
        } else if (isSaf && p.canViewConditions && p.canViewCuerpoTecnico && p.canViewCondicionesCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/condiciones/cuerpo-tecnico')
        } else if (isSaf && p.canViewConditions && p.canViewPagosJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/pagos/jugadores')
        } else if (isSaf && p.canViewConditions && p.canViewCuerpoTecnico && p.canViewPagosCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/pagos/cuerpo-tecnico')
        } else if (isSaf && p.canViewTransferencias && p.canViewTransferenciasReporteSistema) {
          this.redirectIfNotCurrent('/reportes/transferencias')
        } else if (isSaf && p.canViewContratos && p.canViewVencimientosContratosJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/vencimientos/jugadores')
        } else if (isSaf && p.canViewCuerpoTecnico && p.canViewVencimientosContratosCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/vencimientos/cuerpo-tecnico')
        } else if (isSaf && p.canViewContratos && p.canViewAdendasJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/adendas/jugadores')
        } else if (isSaf && p.canViewCuerpoTecnico && p.canViewAdendasCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/adendas/cuerpo-tecnico')
        } else if (isSaf && p.canViewReportFaults && p.canViewInformesPartidosReporteSistema) {
          this.redirectIfNotCurrent('/reportes/informes/partidos')
        } else if (isSaf && p.canViewContratos && p.canViewContratosDetalleJugadoresReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/detalle/jugadores')
        } else if (isSaf && p.canViewCuerpoTecnico && p.canViewContratosDetalleCuerpoTecnicoReporteSistema) {
          this.redirectIfNotCurrent('/reportes/contratos/detalle/cuerpo-tecnico')
        } else {
          this.redirectIfNotCurrent('/')
        }
      }
    },

    redirectIfNotCurrent (path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped>
.top-spacing {
  margin-top: 5em;
}
</style>
